export function implementSeparateWithIndexF() {
  return i => i();
}
//# sourceMappingURL=index.mjs.map